export const INITIAL_STATE = {
  user: {
    _id: 0,
    email: ''
  },
  reviewItems: []
};